/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsPaymentListItem,
    IdentityMelcoModelsPaymentListItemFromJSON,
    IdentityMelcoModelsPaymentListItemFromJSONTyped,
    IdentityMelcoModelsPaymentListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem {
    /**
     * 
     * @type {Array<IdentityMelcoModelsPaymentListItem>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem
     */
    list: Array<IdentityMelcoModelsPaymentListItem>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsPaymentListItemFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem {
    return IdentityMelcoModelsGenericList1MelcoModelsPaymentListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsPaymentListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsPaymentListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsPaymentListItemToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsPaymentListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


